import React from 'react';
import { useSelector } from 'react-redux';
import { authSelectors } from 'redux/auth';
import Logo from 'components/Logo/Logo';
import useBrand from 'hooks/useBrand';

const LayoutLogo = (args) => {

  const isLoggedIn = useSelector(authSelectors.getUserIsLoggedIn);
  const { logo, name } = useSelector(authSelectors.getWorkspace);

  const brand = useBrand();

  // Until auth resolves, the brand logo would flash before the workspace's own
  if (isLoggedIn === null) {
    return null;
  }

  return (
    <Logo
      src={logo?.src}
      srcSet={logo?.srcSet}
      alt={name || brand.name}
      {...args}
    />
  );
};

export default LayoutLogo;
